import React from "react";
import { useDynamicForm } from "../contexts/dynamic-form/useDynamicForm";
import { Box, Container } from "@mui/material";
// import { DynamicFormContextProvider } from "../contexts/dynamic-form/DynamicFormContextProvider";
import { TextBlocksRenderer } from "../components/TextBlocksRenderer";

export const FormThankYouPage = () => {
  const { form } = useDynamicForm();

  return (
    <>
      {/* <DynamicFormContextProvider formId="bz8xla96iyx7lilbzbksp8y1">
      </DynamicFormContextProvider> */}
      <Container maxWidth="md">
        <Box>
          <TextBlocksRenderer content={form.onSubmit.text} />
        </Box>
      </Container>
    </>
  );
};
